import { createRequest } from '@sys/shared/request';
import { useUserStore } from '@/store/modules/user';
import { BRAND_STORAGE_KEYS } from '@sys/shared/constants';
import { cache } from '@sys/shared/utils';

export const request = createRequest({
  baseURL: import.meta.env.VITE_API_BASE,
  getBrandNo: () => {
    const userStore = useUserStore();
    return userStore.brandNo;
  },
  getToken: () => cache.get(BRAND_STORAGE_KEYS.TOKEN, ''),
  getLocale: () => cache.get(BRAND_STORAGE_KEYS.LOCALE, 'zh-CN'),
  onUnauthorized: () => {
    const userStore = useUserStore();
    userStore.logout();
    window.location.href = `${import.meta.env.BASE_URL}login`;
  },
  onForbidden: () => {
    console.warn('权限不足');
  },
});
